const estadosEjemplos = ['Pendiente', 'A corregir', 'Completado'];
export const autorizacionesAdapter = (rawData) => {
  const { data } = rawData;
  if (data?.length > 0) {
    const rows = data?.map((item) => {
      const {
        NRO_SOLICITUD,
        FECHA_MODIFICACION,
        TIPO_SOLICITUD,
        IMPORTE,
        NOMBRE_SOLICITANTE,
        ESTADO,
          RG_ID
      } = item;
      const nroSolicitud = parseInt(RG_ID);
      return {
        nDeSolicitud: {
          descripcion: NRO_SOLICITUD,
          url: `/autorizaciones/detalle-de-solicitud/${nroSolicitud}`,
          target: '',
        },
        ID_FILE_COMPROBANTE: nroSolicitud,
        fecha: FECHA_MODIFICACION,
        importe: IMPORTE,
        importeFormateado: new Intl.NumberFormat('es-AR', {
          style: 'currency',
          currency: 'ARS',
          minimumFractionDigits: 2}).format(IMPORTE),
        tipo: TIPO_SOLICITUD,
        usuario: NOMBRE_SOLICITANTE,
        estado: ESTADO,
        acciones: {
          descripcion: 'Ver más',
          url: `/autorizaciones/detalle-de-solicitud/${nroSolicitud}/`,
          target: '',
        },
      };
    });
    return { rows };
  }
};

export const getAdjuntosSolicitudAdapter = (payload) => {
  if (payload?.length > 0) {
    const rows = payload?.map((item) => {
      return {
        ...item,
        caeCai: item.CAE || "-",
        comprobante: item.DESCRIPCION_TIPO_COMPROBANTE,
        numeroFactura: item.NUMERO ? `${item.ESTABLECIMIENTO}-${item.NUMERO}` : "-",
        razonSocial: item.RAZON_SOCIAL,
        cuit: item.CUIT || "-",
        concepto: item.DESCRIPCION_CONCEPTO_GASTO,
        importe: item.IMPORTE,
        importeFormateado: new Intl.NumberFormat('es-AR', {
          style: 'currency',
          currency: 'ARS',
          minimumFractionDigits: 2}).format(item.IMPORTE),
        motivoGasto: item.DESCRIPCION,
        fecha: item.FECHA,
        acciones: {
          descripcion: 'Ver más',
          url: "/",
          target: '',
        },
      };
    });
    return rows;
  }
}